import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button } from 'react-bootstrap';
import { TRACK_CLICK_MOVE_IN } from '../../../../../../../src/web/utils/dataLayer';
import CurrentPageContext from '../../../../../../contexts/CurrentPageContext';

export default class MoveIn extends React.Component {
  static propTypes = {
    facility: PropTypes.shape({
      id: PropTypes.string,
      hasRentalCenter: PropTypes.bool,
      settings: PropTypes.object.isRequired,
    }).isRequired,
    id: PropTypes.string.isRequired,
    moveInUrl: PropTypes.string,
    text: PropTypes.string.isRequired,
    setTrackAction: PropTypes.func,
  };

  static defaultProps = {
    moveInUrl: undefined,
    setTrackAction: undefined,
  };

  static contextType = CurrentPageContext;

  getMoveInUrl() {
    const { tier, moveInUrl } = this.props;
    const availableUnitId = tier?.availableUnits?.[0];
    if (availableUnitId) { return (`${moveInUrl}/${availableUnitId}`); }
    return moveInUrl;
  }

  onButtonClick() {
    const { setTrackAction } = this.props;
    if (setTrackAction) {
      setTrackAction('moveIn');
    }
  }

  render() {
    const {
      secondaryColorBackgroundClass,
      primaryColorBackgroundHoverClass,
      buttonStyleClass,
    } = this.context;
    const { text, isUnitGroupExpanded, styleMoveInUG } = this.props;
    return (
      <Button
        block
        className={cx('w-100',
          secondaryColorBackgroundClass,
          primaryColorBackgroundHoverClass,
          buttonStyleClass,
          !isUnitGroupExpanded && 'action-reservation',
          isUnitGroupExpanded && styleMoveInUG)}
        href={this.getMoveInUrl()}
        onClick={() => this.onButtonClick()}
        data-testid="actions-movein"
        rel="noopener noreferrer"
        target="_blank"
        {...TRACK_CLICK_MOVE_IN}
      >
        {text}
      </Button>
    );
  }
}
